import { create } from "zustand";

export interface ExtractElementStore {
  // From the selected element
  selectedElementHTML: string | null;
  selectedElementBoundingBox: {
    x: number;
    y: number;

    // Relative to the first positioned parent
    relativeX: number;
    relativeY: number;

    width: number;
    height: number;
  } | null;

  setSelectedElementSnapshot: (
    selectedElementHTML: string,
    selectedElementBoundingBox: {
      x: number;
      y: number;
      relativeX: number;
      relativeY: number;
      width: number;
      height: number;
    } | null,
  ) => void;

  resetStore: () => void;
}

export const useExtractElementStore = create<ExtractElementStore>(
  (set, get) => ({
    selectedElementHTML: null,
    selectedElementBoundingBox: null,
    setSelectedElementSnapshot: (
      selectedElementHTML: string,
      selectedElementBoundingBox: {
        x: number;
        y: number;
        relativeX: number;
        relativeY: number;
        width: number;
        height: number;
      } | null,
    ) => {
      set({ selectedElementHTML, selectedElementBoundingBox });
    },

    resetStore: () => {
      set({
        selectedElementHTML: null,
        selectedElementBoundingBox: null,
      });
    },
  }),
);
